/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Box, Flex, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { useMemo } from 'react';
import { gql, useMutation } from '@apollo/client';
import RichTextEditorField from '../../../components/form/RichTextEditorField';
import RadioValueFormField from '../../../components/form/RadioValueFormField';
import c from '../../../constant';
import * as Yup from 'yup';

const M_CREATE = gql`
	mutation createNewNpDraftInRelation($relationId: String!, $type: NpEnumType!, $subject: String!) {
		createNewNpDraftInRelation(relationId: $relationId, type: $type, subject: $subject) {
			id
			subject
			type
			step
			number
			createdByUser {
				id
				username
				fullName
				fullNameKhmer
				avatar
				position
				office
				department
			}
			viewers {
				id
				createdAt
				createdBy
				userViewer {
					id
					username
					fullName
					fullNameKhmer
					avatar
					department
					office
				}
			}
		}
	}
`;

function RelationCreateModal({ relationId = null, onClose = () => null, onComplete = (createdNpId) => null }) {
	const toast = useToast();
	const { t } = useTranslation();
	const [createNewNpDraftInRelation, { loading }] = useMutation(M_CREATE);

	const validationSchema = useMemo(
		() =>
			Yup.object().shape({
				type: Yup.string().required('required'),
				subject: Yup.string().required('required'),
			}),
		[],
	);

	return (
		<Modal size="2xl" closeOnEsc={!loading} closeOnOverlayClick={!loading} isOpen={true} onClose={onClose}>
			<ModalOverlay />
			<ModalContent borderRadius={c.borderRadius}>
				<ModalHeader pb={0} mb={0}>
					{t('Create a new np or rp')}
				</ModalHeader>
				<ModalCloseButton isDisabled={loading} />
				<ModalBody>
					<Formik
						initialValues={{ type: '', subject: '' }}
						validationSchema={validationSchema}
						onSubmit={(values) => {
							const type = values?.type;
							const subject = values?.subject;
							const variables = { relationId, type, subject };
							createNewNpDraftInRelation({ variables })
								.then(({ data }) => {
									onClose();
									onComplete(data?.createNewNpDraftInRelation);
								})
								.catch((error) => {
									toast({
										title: t(error?.message ? error?.message : 'something went wrong'),
										status: 'error',
										isClosable: true,
										position: 'bottom-right',
									});
								});
						}}
					>
						{({ values }) => (
							<Form>
								<Box mt="2">
									<RadioValueFormField
										name="type"
										label="type"
										disabled={loading}
										required={true}
										radios={[
											{ label: 'Note of Presentation', value: 'NoteOfPresentation' },
											{ label: 'Report', value: 'Report' },
										]}
									/>
									{values?.type && (
										<>
											<RichTextEditorField name="subject" label="Subject" disabled={loading} showToolbar={true} required={true} />
										</>
									)}
									<Flex flex="1" mt={4} mb={2} justifyContent="flex-end" alignItems="center">
										<Button type="submit" isLoading={loading} borderRadius={c.borderRadius} colorScheme="blue" onMouseDown={() => null}>
											{t('Create')}
										</Button>
									</Flex>
								</Box>
							</Form>
						)}
					</Formik>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default RelationCreateModal;
